import { differenceInCalendarDays, startOfDay } from 'date-fns';

import { toZonedTime } from 'date-fns-tz';

export function getRelativeDayLabel(
  tzCode: string,
): 'Today' | 'Yesterday' | 'Tomorrow' {
  const now = new Date();

  const targetTime = toZonedTime(now, tzCode);

  const localDayStart = startOfDay(now);
  const targetDayStart = startOfDay(targetTime);

  const diff = differenceInCalendarDays(targetDayStart, localDayStart);

  if (diff === 0) return 'Today';
  if (diff === -1) return 'Yesterday';
  if (diff === 1) return 'Tomorrow';

  return 'Today';
}
